import { defineStore } from 'pinia'
import type { User } from '@/graphql/types/user'
import { ref } from 'vue'
import client from '@/graphql/apollo'
import { useQuery } from '@vue/apollo-composable'
import { ME_QUERY, type MeQuery, type MeQueryVariables } from '@/graphql/queries/me'

export const useUserStore = defineStore('user', () => {
  const user = ref<User | null>(null)

  async function loadUser() {
    try {
      const query = await client.query<MeQuery, MeQueryVariables>( {
        query: ME_QUERY,
      })
      user.value = query.data?.me
      return user.value
    } catch(error) {
      console.error('loadUser', 'query error %o', error)
      return null
    }
  }

  function clearUser() {
    user.value = null
    localStorage.removeItem('user')
  }

  function init(initUser: User) {
    const saved = localStorage.getItem('user')
    if(saved) {
      user.value = JSON.parse(saved)
      if(user.value?.email === initUser.email) {
      } else {
        user.value = null
      }
    }
    if(user.value) {
      if(user.value.email !== initUser.email) {
        user.value = null
      }
    }
    if(!user.value) {
      user.value = initUser
    }
  }

  return { user, loadUser, clearUser, init }
})
